import React, { useEffect, useState } from 'react';
import { FiMapPin } from 'react-icons/fi';

import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Container,
  Hero,
  Services,
  SpeedConsultation,
  Location,
  Testimonials,
  DrIvaniHero,
  BeforeCaseImage,
  AfterCaseImage,
  ImageWrapperAfter,
  ImageWrapperBefore,
  AccordionSection,
  AccordionHeader,
  AccordionContent,
} from './styles';

import logo from '~/assets/logos/full-logo.svg';
// import draIvaniWelcome from '~/assets/defaults/dra-ivani-welcome.png';
import dentalImplants1After from '~/assets/defaults/after_1_implants.png';
import dentalImplants2After from '~/assets/defaults/after_2_implants.png';
import dentalImplants1Before from '~/assets/defaults/before_1_implants.png';
import dentalImplants2Before from '~/assets/defaults/before_2_implants.png';
import draMichelle from '~/assets/defaults/DraMichelle.png';
import draIvani from '~/assets/defaults/DraIvani.png';
import stamp from '~/assets/defaults/stamp.png';
// import BeforeAfter from '~/assets/defaults/BeforeAfter.png';
import BeforeAfter from '~/assets/tv/implants/before-after.png'; // TODO: placeholder, trocar por defaults/BeforeAfter.png
import locationBig from '~/assets/defaults/location-big.png';
import locationMobile from '~/assets/defaults/location.png';
import InstagramPost from '~/components/InstagramEmbed';
import notice from '~/assets/tv/clear-aligners/notice.png';
import whatsAppSVG from '~/assets/icons/whatsapp.svg';

const DentalAesthetics: React.FC = () => {
  const location = useLocation();
  // const [opened, setOpened] = useState(false);
  const [whatsappMessage, setWhatsappMessage] = useState('');
  const [open, setOpen] = useState('');

  useEffect(() => {
    if (location.pathname.includes('rede-social')) {
      setWhatsappMessage(
        'Olá! Encontrei vocês nas redes sociais e estou interessado em marcar um horário.'
      );
    } else {
      setWhatsappMessage(
        'Olá gostaria de agendar uma avaliação para Estética Dental'
      );
    }
  }, [location.pathname]);

  return (
    <Container>
      <Helmet>
        <title>Estética Odontológica Coi Prime</title>
        <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />
        <link rel="canonical" href="https://coiprime.com.br/estetica" />
      </Helmet>
      <Hero className="position-relative">
        <div className="container h-100 position-relative">
          <div className="row align-items-lg-center h-100">
            <div className="col-lg-6 order-1 order-lg-0 text-center text-lg-start">
              <h1 className="text-white fw-light d-flex flex-column h2 display-lg-4 display-xxl-3 text-center text-lg-start">
                <br />
                <span className="fw-semibold fs-1">
                  Lentes de Contato Barueri, Bethaville Clareamento Dental{' '}
                  Barueri, centro
                </span>
              </h1>
              {/* <p className="h5 h3-lg text-white text-center text-lg-start mt-5 mt-lg-0">
                Coi Prime é referência em Barueri na aplicação de{' '}
                <span className="fw-bold">
                  lentes de contato dental com materiais premium
                </span>
                , utilizando técnicas minimamente invasivas e tecnologia digital
                de última geração.{' '}
              </p> */}
              <div className="d-lg-flex flex-column align-items-center w-100 w-lg-75">
                <a
                  href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="mt-5 btn btn-schedule rounded-pill text-white fs-5 fs-lg-4 fw-medium px-5 py-3"
                  title="Quero Avaliar Meu Caso Agora"
                >
                  Agendar com um Especialista{' '}
                  <img
                    loading="lazy"
                    src={whatsAppSVG}
                    width={24}
                    alt="whatsapp"
                  />
                </a>
                <h2 className="d-block text-center text-white mt-2 fs-4 w-100">
                  “Somente Particular”
                </h2>
              </div>
            </div>
            <div className="col-lg-5 align-self-start d-flex justify-content-center justify-content-lg-end pt-5 order-0 order-lg-1">
              <img loading="lazy" src={logo} alt="logo" />
            </div>
          </div>
        </div>
        <div className="position-absolute d-none d-lg-flex dra-ivani">
          <div className="justify-content-end">
            <img
              loading="lazy"
              src={BeforeAfter}
              alt="Antes/Depois do procedimento estético"
              style={{
                height: '35dvh',
                marginBottom: '10dvh',
                borderRadius: '20px',
              }}
            />
          </div>
        </div>
      </Hero>
      <Services>
        <div className="container">
          <div className="row py-5 px-3 px-lg-0">
            <div className="col-12 bg-gray px-3 py-5 px-lg-5">
              <div className="row justify-content-between align-items-center px-3 px-lg-5">
                <div className="col-7 col-lg-6 col-xl-7">
                  <h2 className="fs-2 fs-lg-1 fw-medium mb-5">
                    Especialistas em Lentes de Contato Dental e Clareamento
                    Dental em Barueri
                  </h2>
                </div>
                <div className="col-5 col-lg-5 mt-n5 mt-lg-0">
                  <img
                    loading="lazy"
                    src={stamp}
                    alt="A clínica mais tecnológica de Barueri"
                    className="d-block ms-auto stamp mt-lg-0 mt-xl-n4 w-100 w-lg-50 w-xl-auto"
                  />
                </div>
                <div className="col-lg-10 mt-4 mt-xl-n4">
                  <p className="fw-light fs-lg-5 text-black mb-5">
                    Nossa equipe é altamente capacitada em odontologia estética,
                    com foco exclusivo em{' '}
                    <span className="fw-semibold">
                      lentes de contato dental em cerâmica de alta resistência{' '}
                    </span>
                    e clareamentos realizados com protocolos diferenciados com
                    maior durabilidade e dentes mais claros.
                  </p>
                </div>
                <div className="align-self-start d-flex justify-content-between px-3 px-lg-5">
                  <DrIvaniHero>
                    <img
                      loading="lazy"
                      className="w-100 col-sm-6 front-mobile front-sm d-none d-sm-block px-2"
                      src={draIvani}
                      alt="Dra. Ivani"
                    />
                    <img
                      loading="lazy"
                      className="w-100 front-mobile d-block d-sm-none mb-4"
                      src={draIvani}
                      alt="Dra. Ivani"
                    />
                  </DrIvaniHero>
                  <DrIvaniHero>
                    <img
                      loading="lazy"
                      className="w-100 col-sm-6 front-mobile front-sm d-none d-sm-block px-2"
                      src={draMichelle}
                      alt="Dra. Michelle"
                    />
                    <img
                      loading="lazy"
                      className="w-100 front-mobile d-block d-sm-none mb-4"
                      src={draMichelle}
                      alt="Dra. Michelle"
                    />
                  </DrIvaniHero>
                </div>
              </div>
              <div className="row mt-5 pt-5">
                <h3 className="fs-5 fs-lg-4 fw-medium text-black mb-3">
                  - A Dra Ivani tem mais de 30 anos, com várias especializações
                  e estética dental - CROSP 66115
                </h3>
                <ul className="ps-lg-5 ms-lg-3 mb-5">
                  <li className="text-secondary">
                    <p className="mb-2">
                      <span className="fw-semibold">
                        Especialista em Implantodontia
                      </span>
                    </p>
                  </li>
                  <li className="text-secondary">
                    <p className="mb-2">
                      <span className="fw-semibold">
                        Especialista em Cirurgia Oral menor
                      </span>
                    </p>
                  </li>
                  <li className="text-secondary">
                    <p className="mb-2">
                      <span className="fw-semibold">
                        Especialista em Ortodontia
                      </span>
                    </p>
                  </li>
                  <li className="text-secondary">
                    <p className="mb-2">
                      <span className="fw-semibold">
                        Especialista em Harmonização Orofacial
                      </span>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="row mt-2 pt-2">
                <h3 className="fs-5 fs-lg-4 fw-medium text-black mb-3">
                  - A mais de 10 anos, especialista em dentística- Dra Michelle
                  Dos Santos Brito - CROSP 127239
                </h3>
                <ul className="ps-lg-5 ms-lg-3 mb-5">
                  <li className="text-secondary">
                    <p className="mb-2">
                      <span className="fw-semibold">
                        Materiais premium de alta translucidez
                      </span>
                    </p>
                  </li>
                  <li className="text-secondary">
                    <p className="mb-2">
                      <span className="fw-semibold">
                        Tecnologia de escaneamento 3D sem moldagens
                        desconfortáveis
                      </span>
                    </p>
                  </li>
                  <li className="text-secondary">
                    <p className="mb-2">
                      <span className="fw-semibold">
                        Planejamento digital para resultados naturais e
                        harmônicos
                      </span>
                    </p>
                  </li>
                  <li className="text-secondary">
                    <p className="mb-2">
                      <span className="fw-semibold">
                        Com protocolos rápidos, seguro e preciso.
                      </span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Services>
      <SpeedConsultation>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bg-gray">
                <h2 className="h5 h3-lg">
                  Transformações Reais com Lentes e Clareamento
                </h2>
                <div className="align-self-start d-flex justify-content-between px-0 px-lg-5 mb-5">
                  <div className="col-lg-6 m-2 col-xl-6 col-sm-6 col-md-6 px-1 px-lg-5 front-mobile front-sm d-none d-sm-block">
                    <h3 className="text-center h6 h4-lg">Clareamento Dental</h3>
                    <InstagramPost
                      linkStr="https://www.instagram.com/p/DIhbkSApXrG"
                      captioned={false}
                      width="100%"
                    />
                  </div>
                  <div className="col-lg-6 m-2 col-xl-6 col-sm-6 col-md-6 px-1 px-lg-5 front-mobile front-sm d-none d-sm-block">
                    <h3 className="text-center h6 h4-lg">Lentes de Contato</h3>
                    <InstagramPost
                      linkStr="https://www.instagram.com/reel/DL09ig7pbE-/?igsh=MXdkNXRoMWRteG0yMA=="
                      captioned={false}
                      width="100%"
                    />
                  </div>
                </div>
                <div className="row w-100 front-mobile d-block d-sm-none">
                  <div className="w-100 front-mobile d-block d-sm-none">
                    <h3 className="text-center h6 h4-lg">Clareamento Dental</h3>
                    <InstagramPost
                      linkStr="https://www.instagram.com/p/DIhbkSApXrG"
                      captioned={false}
                      width="100%"
                    />
                  </div>
                  <div className="w-100 front-mobile d-block d-sm-none">
                    <h3 className="text-center h6 h4-lg">Lentes de Contato</h3>
                    <InstagramPost
                      linkStr="https://www.instagram.com/reel/DL09ig7pbE-/?igsh=MXdkNXRoMWRteG0yMA=="
                      captioned={false}
                      width="100%"
                    />
                  </div>
                </div>
                <div className="align-self-start d-flex justify-content-between px-3 px-lg-5 mb-5">
                  <div className="col-lg-6 col-xl-6 col-sm-6 px-1 px-sm-1 px-lg-5">
                    <ImageWrapperBefore>
                      <BeforeCaseImage
                        alt="Caso 1 lentes de contato dental e clareamento dental antes"
                        src={dentalImplants1Before}
                        about="Caso 1 lentes de contato dental e clareamento dental antes"
                      />
                    </ImageWrapperBefore>
                  </div>
                  <div className="col-lg-6 col-xl-6 col-sm-6 px-1 px-lg-5">
                    <ImageWrapperAfter>
                      <AfterCaseImage
                        src={dentalImplants1After}
                        alt="Caso 2 lentes de contato dental e clareamento dental depois"
                        about="Caso 2 lentes de contato dental e clareamento dental depois"
                      />
                    </ImageWrapperAfter>
                  </div>
                </div>
                <div className="align-self-start d-flex justify-content-between px-3 px-lg-5">
                  <div className="col-lg-6 col-xl-6 col-sm-6 px-1 px-lg-5">
                    <ImageWrapperBefore>
                      <BeforeCaseImage
                        alt="Caso 2 lentes de contato dental e clareamento dental antes"
                        src={dentalImplants2Before}
                        about="Caso 2 lentes de contato dental e clareamento dental antes"
                      />
                    </ImageWrapperBefore>
                  </div>
                  <div className="col-lg-6 col-xl-6 col-sm-6 px-1 px-lg-5">
                    <ImageWrapperAfter>
                      <AfterCaseImage
                        src={dentalImplants2After}
                        alt="Caso 2 lentes de contato dental e clareamento dental depois"
                        about="Caso 2 lentes de contato dental e clareamento dental depois"
                      />
                    </ImageWrapperAfter>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="bg-gray">
                <h2 className="h5 h3-lg">
                  Sorrir com Segurança é Mais do que Estética – É Conexão com o
                  Sucesso
                </h2>
                <p className="fw-light mb-4">
                  Um estudo da Universidade{' '}
                  <span className="fw-semibold">King's College London</span>,
                  pela <span className="fw-semibold">Revista Exame</span>,
                  mostrou que dentes bonitos podem influenciar diretamente o
                  sucesso social e profissional das pessoas. A estética do
                  sorriso impacta nas entrevistas de emprego, relações pessoais
                  e autoestima. Pessoas com dentes brancos e alinhados
                  transmitem sensações de confiança e inteligência.
                </p>
                <p className="fw-light mb-5">
                  Fonte:{' '}
                  <a href="https://exame.com/carreira/sorriso-bonito-afeta-carreira/">
                    https://exame.com/carreira/sorriso-bonito-afeta-carreira/
                  </a>
                </p>
                <p className="fw-bold mb-5">
                  <span>
                    “Seu sorriso pode ser a chave para o reconhecimento pessoal
                    e profissional que você merece”
                  </span>
                </p>
                <div>
                  <img
                    loading="lazy"
                    src={notice}
                    alt="notice"
                    className="w-100"
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="bg-gray">
                <h2 className="h5 h3-lg">
                  Tratamentos de Estética Avançada na Coi Prime
                </h2>
                <ul className="ps-lg-5 ms-lg-3 mb-5">
                  <li className=" ">
                    <p className="fw-bold mb-0">Lentes de Contato Dental</p>
                    <p>
                      Harmonizam cor, forma e alinhamento dos dentes.
                      Ultrafinas, naturais e duráveis.
                    </p>
                  </li>
                  <li className=" ">
                    <p className="fw-bold mb-0">Clareamento Combinado</p>
                    <p>
                      Sessões em consultório + kit personalizado com gel,
                      orientado e supervisionado.
                    </p>
                  </li>
                  <li className=" ">
                    <p className="fw-bold mb-0">Facetas Diretas em Resina</p>
                    <p>
                      Opção acessível e estética para correção rápida de
                      imperfeições.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </SpeedConsultation>
      <Testimonials>
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <div className="bg-gray">
                <h2 className="h6 h5-lg fw-light mb-5">
                  {/* Depoimentos Escritos e Notas Google <br /> */}
                  <span className="h2 h1-lg fw-medium">
                    Pacientes que Brilham com Novos Sorrisos
                  </span>
                </h2>
                <div>
                  <p className="fw-semibold mb-0">
                    <span>
                      “Sou maquiadora, minha imagem é tudo. Depois das lentes,
                      meu feed ganhou outra vida.”
                    </span>
                  </p>
                  <p className="fw-bold mb-5">— Natália M., 29 anos</p>
                  <p className="fw-semibold mb-0">
                    <span>
                      “Fiz clareamento e lentes. Hoje falo melhor em público e
                      até consegui promoção.”
                    </span>
                  </p>
                  <p className="fw-bold mb-5">— João F., 34 anos</p>
                </div>
              </div>
            </div>
            <div className="w-100 col-12">
              <h2 className="h6 h5-lg fw-light mb-5">
                {/* Depoimentos Escritos e Notas Google <br /> */}
                <span className="h2 h1-lg fw-medium">
                  Suas Dúvidas Respondidas com Clareza
                </span>
              </h2>
              <div>
                <AccordionSection>
                  <AccordionHeader
                    onClick={() => setOpen(open === '1' ? '' : '1')}
                  >
                    Lentes desgastam os dentes?
                    <span>{open === '1' ? '▲' : '▼'}</span>
                  </AccordionHeader>
                  <AccordionContent isOpen={open === '1'}>
                    Sim, é necessário um leve desgaste para manter a anatomia
                    das arcadas dentárias.
                  </AccordionContent>
                </AccordionSection>
                <AccordionSection>
                  <AccordionHeader
                    onClick={() => setOpen(open === '2' ? '' : '2')}
                  >
                    Quanto tempo duram as lentes?
                    <span>{open === '2' ? '▲' : '▼'}</span>
                  </AccordionHeader>
                  <AccordionContent isOpen={open === '2'}>
                    Isso depende do material utilizado e de como o paciente
                    cuida, existem casos de pacientes com mais de 10 anos.
                  </AccordionContent>
                </AccordionSection>
                <AccordionSection>
                  <AccordionHeader
                    onClick={() => setOpen(open === '3' ? '' : '3')}
                  >
                    Clareamento causa sensibilidade?
                    <span>{open === '3' ? '▲' : '▼'}</span>
                  </AccordionHeader>
                  <AccordionContent isOpen={open === '3'}>
                    Pode causar sensibilidade sim, mas é momentânea, mas ainda
                    sim na maioria não tem sensibilidade porque nosso protocolo
                    de clareamento é completo, com cuidados antes e depois da
                    aplicação.
                  </AccordionContent>
                </AccordionSection>
                <AccordionSection>
                  <AccordionHeader
                    onClick={() => setOpen(open === '4' ? '' : '4')}
                  >
                    Dá pra fazer estética com aparelho?
                    <span>{open === '4' ? '▲' : '▼'}</span>
                  </AccordionHeader>
                  <AccordionContent isOpen={open === '4'}>
                    Sim, se o aparelho for alinhador transparente é possível
                    clarear os dentes durante o tratamento.
                  </AccordionContent>
                </AccordionSection>
                <AccordionSection>
                  <AccordionHeader
                    onClick={() => setOpen(open === '5' ? '' : '5')}
                  >
                    Estética dental é acessível?
                    <span>{open === '5' ? '▲' : '▼'}</span>
                  </AccordionHeader>
                  <AccordionContent isOpen={open === '5'}>
                    Sim, totalmente acessível pois é menor custo com maior
                    qualidade e ainda temos planos de parcelamentos em até 12X
                    no cartão de crédito. E também pode usar seu FGTS de forma
                    rápida, segura e sem comprometer seu orçamento.
                  </AccordionContent>
                </AccordionSection>
              </div>
            </div>
          </div>
        </div>
      </Testimonials>
      <Hero className="position-relative">
        <div className="container h-100 position-relative">
          <div className="row align-items-lg-center h-100">
            <div className="col-lg-7 order-1 order-lg-0 text-center text-lg-start">
              <h2 className="text-white fw-light d-flex flex-column h2 display-lg-4 display-xxl-3 text-center text-lg-start">
                <br />
                Pronto para se destacar com um sorriso inesquecível
              </h2>
              <p className="h5 h3-lg text-white text-center text-lg-start mt-5 mt-lg-0">
                Agende sua avaliação e descubra como podemos personalizar seu
                tratamento com máxima estética, conforto e naturalidade. A Coi
                Prime está pronta para fazer você sorrir com confiança.
              </p>
              <div className="d-lg-flex flex-column align-items-start w-100 w-lg-75">
                <a
                  href={`https://api.whatsapp.com/send?phone=551141981987&text=${whatsappMessage}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="mt-5 btn btn-schedule rounded-pill text-white fs-5 fs-lg-4 fw-medium px-5 py-3"
                  title="Quero Avaliar Meu Sorriso com Especialistas"
                >
                  Quero Avaliar Meu Sorriso com Especialistas{' '}
                  <img
                    loading="lazy"
                    src={whatsAppSVG}
                    width={24}
                    alt="whatsapp"
                  />
                </a>
                <small className="d-block text-white mt-2 fs-6 w-100">
                  *Não atendemos convênios e Planos&nbsp;de&nbsp;Saúde
                </small>
              </div>
            </div>
          </div>
        </div>
      </Hero>
      <Location>
        <div className="container py-5 my-5">
          <div className="row">
            <div className="col-12">
              <div className="bg-gray-mobile">
                <div className="row justify-content-between align-items-center align-items-xxl-end">
                  <div className="col-lg-5 mb-5 mb-lg-0 pe-lg-0 position-relative">
                    <img
                      loading="lazy"
                      src={locationBig}
                      alt="A faixada da clínica a noite com uma luz azul e o letreiro onde está escrito COI Prime Odontologia aceso com uma luz branca"
                      className="w-100 w-md-75 w-lg-100 d-block d-lg-none d-xl-block mx-md-auto mx-lg-0"
                    />
                    <img
                      loading="lazy"
                      src={locationMobile}
                      alt="A faixada da clínica a noite com uma luz azul e o letreiro onde está escrito COI Prime Odontologia aceso com uma luz branca"
                      className="w-100 w-md-75 w-lg-100 d-none d-lg-block d-xl-none mx-md-auto mx-lg-0"
                    />
                    <div className="detail" />
                  </div>
                  <div className="col-lg-7 bg-gray">
                    <div>
                      <h3 className="h6 h5-lg fw-light text-black">
                        LOCALIZAÇÃO
                      </h3>
                      <h2 className="h2 h1-lg mb-5 text-black">
                        Conheça <br className="d-block d-lg-none" />
                        nossa clínica
                      </h2>
                    </div>
                    <div className="d-flex align-items-lg-center mb-4">
                      <FiMapPin size={30} color="#BE7E38" />
                      <div className="ms-2">
                        <h3 className="fs-6 fw-normal mb-0">Endereço:</h3>
                        <p className="mb-0">
                          Av. Trindade, 165 – Bethaville I, Barueri – SP,
                          06404-326
                        </p>
                      </div>
                    </div>
                    <ul className="ps-lg-5 ms-lg-3 mb-5">
                      <li className="text-secondary">
                        <p className="mb-0">Fácil Acesso em Barueri</p>
                      </li>
                      <li className="text-secondary">
                        <p className="mb-0">
                          A 5 minutos da estação de trem e terminal de ônibus
                        </p>
                      </li>
                      <li className="text-secondary">
                        <p className="mb-0">Estacionamento gratuito no local</p>
                      </li>
                      <li className="text-secondary">
                        <p className="mb-0">
                          Clínica térrea com acessibilidade para PCDs
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row justify-content-between align-items-center mt-5">
                  {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.724568093344!2d-46.87191932461697!3d-23.50642827883757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cf03a366ebf507%3A0x49c36685e3138fee!2sCOI%20Prime%20Odontologia%20-%20Cl%C3%ADnica%20Odontol%C3%B3gica%20em%20Barueri%20-%20Dentista%20em%20Barueri!5e0!3m2!1spt-BR!2sbr!4v1750097120916!5m2!1spt-BR!2sbr"
                    width="600"
                    height="450"
                    title="Ver rotas"
                    referrerPolicy="no-referrer-when-downgrade"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Location>
    </Container>
  );
};

export default DentalAesthetics;
